/**
 * Security utilities - basic devtools mitigation and copy protection.
 * NOTE: These are deterrents, not fool-proof protections. Determined users
 * can always bypass client-side restrictions.
 */

const IS_PRODUCTION = import.meta.env.PROD;

export function initSecurityProtections() {
  if (!IS_PRODUCTION) return;

  // Disable right-click context menu
  document.addEventListener("contextmenu", (e) => {
    e.preventDefault();
  });

  // Block common keyboard shortcuts for devtools / view source / copy
  document.addEventListener("keydown", (e) => {
    // F12
    if (e.key === "F12") {
      e.preventDefault();
      return;
    }
    // Ctrl+Shift+I / Cmd+Option+I (DevTools)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "I") {
      e.preventDefault();
      return;
    }
    // Ctrl+Shift+J / Cmd+Option+J (Console)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "J") {
      e.preventDefault();
      return;
    }
    // Ctrl+Shift+C / Cmd+Option+C (Inspect element)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "C") {
      e.preventDefault();
      return;
    }
    // Ctrl+U / Cmd+U (View source)
    if ((e.ctrlKey || e.metaKey) && e.key === "u") {
      e.preventDefault();
      return;
    }
    // Ctrl+S / Cmd+S (Save page)
    if ((e.ctrlKey || e.metaKey) && e.key === "s") {
      e.preventDefault();
      return;
    }
  });

  // Disable text selection on body (except inputs/textareas)
  document.addEventListener("selectstart", (e) => {
    const target = e.target as HTMLElement;
    if (
      target.tagName === "INPUT" ||
      target.tagName === "TEXTAREA" ||
      target.isContentEditable
    ) {
      return;
    }
    e.preventDefault();
  });

  // Disable drag
  document.addEventListener("dragstart", (e) => {
    e.preventDefault();
  });
}
